var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('div',[_c('b-dropdown-item',{staticClass:"drop-item",attrs:{"to":_vm.route}},[_c('img',{staticClass:"dropItem",attrs:{"src":require(`@/assets/${_vm.image}`),"alt":`${_vm.altTxt}`}}),_vm._v(" "+_vm._s(_vm.text)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }